// extracted by mini-css-extract-plugin
module.exports = {"month-nav-group":"BottomNav_month-nav-group__qQt1o","month-nav-group__nav":"BottomNav_month-nav-group__nav__3THBn","nav-icon-wrapper":"BottomNav_nav-icon-wrapper__X4EtS"};